import classes from './base-button.module.scss';

const variants = {
  primary: classes.primary,
  secondary: classes.secondary,
  tertiary: classes.tertiary
} as const;

const sizes = {
  small: classes.small,
  medium: classes.medium,
  large: classes.large
} as const;

// Export disabled variants for conditional application
export const variantDisabledClasses = {
  primary: classes.primaryDisabled,
  secondary: classes.secondaryDisabled,
  tertiary: classes.tertiaryDisabled
} as const;

export const iconSizeClasses = {
  small: classes.iconSmall,
  medium: classes.iconMedium,
  large: classes.iconLarge
} as const;

type Variant = keyof typeof variants;
type Size = keyof typeof sizes;

export { variants, sizes, type Variant, type Size };
